import produce from 'immer';
import { CommonAction } from '../actions/common';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Common } from '../types/Common';
const common = (
  state: Common = initialState.common,
  action: CommonAction
): Common => {
  return produce<Common, Common>(state, draft => {
    switch (action.type) {
      case Constants.ADD_PASSWORD_SUCCESS:
        draft.passwords.push(action.payload.password);
        break;
      case Constants.REQUEST_PASSWORDS:
        draft.fetchingPasswords = true;
        draft.fetchingPasswordsFailed = false;
        break;
      case Constants.REQUEST_PASSWORDS_SUCCESS:
        draft.fetchingPasswords = false;
        draft.fetchingPasswordsFailed = false;
        draft.passwords = action.payload.passwords;
        break;
      case Constants.REQUEST_PASSWORDS_FAILED:
        draft.fetchingPasswords = false;
        draft.fetchingPasswordsFailed = true;
        break;
      case Constants.REQUEST_CERTIFICATES:
        draft.fetchingCertificates = true;
        draft.fetchingCertificatesFailed = false;
        break;
      case Constants.REQUEST_CERTIFICATES_SUCCESS:
        draft.fetchingCertificates = false;
        draft.fetchingCertificatesFailed = false;
        draft.certificates = action.payload.certificates;
        break;
      case Constants.REQUEST_CERTIFICATES_FAILED:
        draft.fetchingCertificates = false;
        draft.fetchingCertificatesFailed = true;
        break;
      case Constants.REQUEST_LICENSES:
        draft.fetchingLicenses = true;
        draft.fetchingLicensesFailed = false;
        break;
      case Constants.REQUEST_LICENSES_SUCCESS:
        draft.fetchingLicenses = false;
        draft.fetchingLicensesFailed = false;
        draft.licenses = action.payload.licenses;
        break;
      case Constants.REQUEST_LICENSES_FAILED:
        draft.fetchingLicenses = false;
        draft.fetchingLicensesFailed = true;
        break;
      case Constants.ADD_LICENSE:
        draft.licenses.push(action.payload.license);
        break;
      case Constants.ADD_CERTIFICATE: {
        const { alias, vmid } = action.payload.certificate;
        draft.certificates.push({ alias, vmid });
        break;
      }
      case Constants.REQUEST_TENANTS:
        draft.fetchingTenants = true;
        draft.fetchingTenantsFailed = false;
        break;
      case Constants.REQUEST_TENANTS_SUCCESS:
        const { tenants } = action.payload;
        draft.fetchingTenants = false;
        draft.fetchingTenantsFailed = false;
        draft.tenants = tenants;
        break;
      case Constants.REQUEST_TENANTS_FAILED:
        draft.fetchingTenants = false;
        draft.fetchingTenantsFailed = true;
        draft.tenants = [];
        break;
    }
  });
};

export default common;
